<div class="horizontal-filter">
  @for (containerItem of compData?.container?.data; track containerItem) {
    <div class="filter-wrap">
      <div class="filter-box flex-container ion-align-items-center">
        <label class="filter-heading" for="sortby">{{ containerItem?.title }}</label>
        <select id="sortby" name="sortby" [(ngModel)]="selectedOption"
          (ngModelChange)="onContainerOptionSelect($event, containerItem)">
          <option [ngValue]="null">{{containerItem?.title}}</option>
          @for (item of containerItem?.options; track item) {
            <option [ngValue]="item">
              {{ item?.title }}
            </option>
          }
        </select>
      </div>
    </div>
  }
</div>
